(function (upp) {
    'use strict';

    var $EVENTS = {
        authenticated : 'login:authenticated',
        no_more_authenticated : 'login:no_more_authenticated',
        open_login : 'login:open-login',
        close_login : 'login:close-login',
        close : 'login:close'
    };

    upp.factory('authenticationBuilder', function () {
        /**
         * Authentication main class
         * @param username
         * @param principal
         * @param type
         * @constructor
         */
        function Authentication(username, principal, type) {
            this.username = username;
            this.principal = principal;
            this.type = type;
        }

        Authentication.prototype.isLogged = function () {
            return this.principal !== undefined;
        };

        Authentication.prototype.hasRole = function () {
            // TODO: implement
            return true;
        };

        /**
         * extends Authentication
         * @param data optional, the cause of the anonymous or other data..
         * @constructor
         */
        function Anonymous(data) {
            this.data = data;
            this.type = 'anonymous';
        }


        Anonymous.prototype.isLogged = function () {
            return false;
        };

        Anonymous.prototype.hasRole = function () {
            return false;
        };

        /**
         * extends Authentication
         * UsernamePasswordAuth para UsernamePasswordProvider
         * @param username
         * @param password
         * @constructor
         */
        function UsernamePasswordAuth(username, password) {
            this.username = username;
            this.password = password;
            this.type = 'UsernamePassword';
        }

        UsernamePasswordAuth.prototype.isLogged = function () {
            return false;
        };

        UsernamePasswordAuth.prototype.hasRole = function () {
            return false;
        };

        /**
         * extends Authentication
         * TokenAuth para TokeProvider
         * @param token
         * @constructor
         */
        function TokenAuth(token) {
            this.username = undefined;
            this.token = token;
            this.type = 'Token';
        }

        TokenAuth.prototype.isLogged = function () {
            return false;
        };

        TokenAuth.prototype.hasRole = function () {
            return false;
        };

        //  principal
        function User(username, password, userId, isAdmin, token, username_display, registeredAt) {
            this.username = username;
            this.userId = userId;
            this.admin = isAdmin;
            this.token = token;
            this.password = password;
            this.username_display = username_display;
            this.registeredAt = registeredAt;
        }

        User.prototype.isAdmin = function () {
            return this.admin && typeof this.admin === 'boolean';
        };

        return {
            /**
             * Authentication with principal
             * @param username
             * @param userId
             * @param isAdmin
             * @param token
             * @param type
             * @param usernameDisplay
             * @return {Authentication}
             */
            build : function (username, userId, isAdmin, token, type, usernameDisplay, registeredAt) {
                var principal = undefined;
                // maybe pull up the username & principal empty
                if (username) {
                    var _isAdmin = false,
                        _userId = -1;
                    if (isAdmin) {
                        _isAdmin = isAdmin;
                    }

                    if (userId) {
                        _userId = userId;
                    }

                    principal = new User(username, undefined, _userId, _isAdmin, token, usernameDisplay, registeredAt);
                }

                return new Authentication(username, principal, type);
            },
            usernamePassword : function (username, password) {
                return new UsernamePasswordAuth(username, password);
            },
            token : function (token) {
                return new TokenAuth(token);
            },
            anonymous : function (data) {
                return new Anonymous(data);
            }
        }
    });

    upp.service('contextHolderManager', ['storage', 'authenticationBuilder',
        function (storage, AuthenticationBuilder) {
            var sessionContextHolder = (function () {
                var _token = undefined;

                var context = {
                        authentication : AuthenticationBuilder.anonymous()
                    },
                    tokenKey = 'upplicationToken';

                var getContext = function () {
                    return context;
                };
                /**
                 *removeAll
                 * @param authentication never undefined
                 */
                var setAuthentication = function (authentication) {
                    context.authentication = authentication;
                    if (!authentication.isLogged()) {
                        setToken(undefined);
                    }
                };

                var setToken = function (token) {
                    _token = token;
                    storage.set(tokenKey, token);
                };

                var getToken = function () {
                    return _token || storage.get(tokenKey);
                };

                return {
                    get : getContext,
                    setToken : setToken,
                    getToken : getToken,
                    setAuthentication : setAuthentication
                };
            })();

            // devolvemos
            return {
                // protected
                _setAuthentication : sessionContextHolder.setAuthentication,
                _setToken : sessionContextHolder.setToken,
                _getToken : sessionContextHolder.getToken,
                // public
                get : sessionContextHolder.get
            };

        }]);

    upp.service('authManager', ['$q', '$http', '$rootScope', 'securityUtils', 'utils', 'authenticationBuilder', 'contextHolderManager',
        function ($q, $http, $rootScope, securityUtils, utils, AuthenticationBuilder, contextHolderManager) {
            var urlRestService = $UPP.URL_UPPLICATION_REST_SERVICE + 'users/';

            var _createAuthentication = function (response, type) {
                var data = response.data;

                return AuthenticationBuilder.build(data.username, data.idUsuario, data.admin, data.token, type,
                    data.username_display, data.registeredAt);
            };

            var _createAnonymousAuthentication = function () {
                return AuthenticationBuilder.anonymous();
            };

            var _createAnonymousAuthenticationPromise = function () {
                // no tenemos usuario: por tanto
                // devolvemos promesa sin authentication
                var deferred = $q.defer();
                var promise = deferred.promise;
                // Simulate resolving of promise  with success
                deferred.resolve(_createAnonymousAuthentication());
                return promise;
            };

            /**
             * traducir: encargado de logearse con el authentication UsernamePasswordAuth
             * @type {*} Provider
             */
            var usernamePasswordProvider = (function () {
                var _postLogin2server = function (username, password) {
                    return $http.post(urlRestService + 'login', {username : username, password : password});
                };

                var login = function (authentication) {
                    // tenemos una lista de mecanismos authentication:
                    if (authentication && authentication.username && authentication.password) {
                        return _postLogin2server(authentication.username, authentication.password)
                            .then(function (response) {
                                // devolvemos la promesa con el authentication nuevo:
                                return _createAuthentication(response, 'UsernamePassword');
                            });
                    } else {
                        // no tenemos usuario:
                        return _createAnonymousAuthenticationPromise();
                    }
                };

                var logout = function () {
                    // logout!
                    return $http.post(urlRestService + "logout", {}, securityUtils.getHttpAuthHeader())
                        .then(function () {
                            return _createAnonymousAuthentication();
                        });
                };

                /**
                 * Only UsernamePasswordAuth allowed
                 * @param authentication
                 * @return {Boolean}
                 */
                var check = function (authentication) {
                    return authentication !== undefined &&
                        authentication.type === 'UsernamePassword';
                };

                return {
                    login : login,
                    logout : logout,
                    check : check
                };
            })();

            var tokenProvider = (function () {

                var _postLoginToken2server = function (token) {
                    return $http.post(urlRestService + 'loginToken', {token : token});
                };

                /**
                 * Check if the given token by the actual user is valid, in that case, create the session
                 *
                 * @method loginToken
                 * @param {String} authentication
                 * @return {Promise} Returns a promise that will be fulfilled(returns the username) or rejected(return the error)
                 */
                var loginToken = function (authentication) {
                    if (authentication && authentication['token']) {
                        return _postLoginToken2server(authentication['token'])
                            .then(function (response) {
                                return _createAuthentication(response, 'Token');
                            });
                    } else {
                        // no tenemos token:
                        return _createAnonymousAuthenticationPromise();
                    }
                };

                var logout = function () {
                    return $http.post(urlRestService + "logout", {}, securityUtils.getHttpAuthHeader())
                        .then(function () {
                            return _createAnonymousAuthentication();
                        });
                };
                /**
                 * Only TokenAuth allowed
                 * @param authentication
                 * @return {Boolean}
                 */
                var check = function (authentication) {
                    return authentication !== undefined &&
                        authentication.type === 'Token';
                };

                return {
                    login : loginToken,
                    logout : logout,
                    check : check
                };
            })();

            /**
             * Check if the username & password given by the actual user is valid, in that case, create the session
             *
             * @method login
             * @param {String} authentication
             * @return {Promise} Returns a promise that will be fulfilled(returns the username) or rejected(return the error)
             */
            var login = function (authentication) {

                var setLogged = function (authentication) {
                    contextHolderManager._setAuthentication(authentication);
                    // TODO: ¡revisar!
                    if (authentication.principal !== undefined &&
                        authentication.principal.token !== undefined) {
                        contextHolderManager._setToken(authentication.principal.token);
                    }

                    $rootScope.$broadcast('event:' + $EVENTS.authenticated, authentication);
                };
                var setAnonymous = function () {
                    var auth = _createAnonymousAuthentication();
                    contextHolderManager._setAuthentication(auth);
                    // TODO: ¿throw event?

                };

                // vemos cual es el que se adapta:
                if (usernamePasswordProvider.check(authentication)) {
                    return usernamePasswordProvider.login(authentication).then(
                        // success
                        function (authentication) {
                            if (authentication.isLogged()) {
                                setLogged(authentication);
                            } else {
                                setAnonymous();
                            }
                            return authentication;
                        },
                        // unknown error
                        function (err) {
                            setAnonymous();
                            return AuthenticationBuilder.anonymous(err);
                        });
                } else if (tokenProvider.check(authentication)) {
                    return tokenProvider.login(authentication).then(
                        // success
                        function (authentication) {
                            if (authentication.isLogged()) {
                                setLogged(authentication);
                            } else {
                                setAnonymous();
                            }
                            return authentication;
                        },
                        // unknown error
                        function (err) {
                            setAnonymous();
                            return AuthenticationBuilder.anonymous();
                        });
                } else {
                    return _createAnonymousAuthenticationPromise().then(function () {
                        setAnonymous();
                        return AuthenticationBuilder.anonymous();
                    });
                }
            };

            var _setLogout = function () {
                var auth = _createAnonymousAuthentication();
                contextHolderManager._setAuthentication(auth);
            };

            /**
             * Removes the object user that was stored in memory, broadcast the event, and inform the server through API REST
             *
             * @method logout
             */
            var logout = function (authentication) {
                if (usernamePasswordProvider.check(authentication)) {
                    return usernamePasswordProvider.logout(authentication)
                        .then(function (authReturned) {// success
                            _setLogout();
                            return authReturned;
                        });
                } else if (tokenProvider.check(authentication)) {
                    return tokenProvider.logout(authentication)
                        .then(function (authentication) {// success
                            _setLogout();
                            return authentication;
                        });
                } else {
                    return _createAnonymousAuthenticationPromise()
                        .then(function () {
                            _setLogout();
                            return AuthenticationBuilder.anonymous();
                        });
                }
            };

            return {
                login : login,
                logout : logout
            };
        }]);

    upp.service('securityUtils', ['contextHolderManager',
        function (contextHolderManager) {
            var getHttpAuthHeader = function () {
                if (contextHolderManager.get().authentication.isLogged()) {
                    return {
                        headers : { Authorization : 'BASIC ' + contextHolderManager._getToken() }
                    };

                } else {
                    return undefined;
                }
            };

            return {
                getHttpAuthHeader : getHttpAuthHeader
            };
        }]);

    upp.service('security', ['$location', '$q', 'utils', '$rootScope', 'contextHolderManager', 'authenticationBuilder', 'loginManager', 'authManager', 'storage',
        function ($location, $q, utils, $rootScope, contextHolderManager, authenticationBuilder, loginManager, authManager, storage) {
            var _configRedirectionIfUserLogoutsAndStaysInSecureZone = function (authentication, options) {
                if (authentication && authentication.isLogged() && options && options.scope) {
                    options.scope.$on('event:' + $EVENTS.no_more_authenticated, function () { //listen to the event 'event:login:no_more_authenticated'
                        $location.path('/'); //redirect to home
                    });
                }
            };

            var _createAnonymousAuthenticationPromise = function () {
                // no tenemos usuario: por tanto
                // devolvemos promesa sin authentication
                var deferred = $q.defer();
                var promise = deferred.promise;
                // Simulate resolving of promise  with success
                deferred.resolve(authenticationBuilder.anonymous());
                return promise;
            };

            var _createRegisteredAuthenticationPromise = function (authentication) {
                // no tenemos usuario: por tanto
                // devolvemos promesa sin authentication
                var deferred = $q.defer();
                var promise = deferred.promise;
                // Simulate resolving of promise  with success
                deferred.resolve(authentication);
                return promise;
            };

            /**
             * Initialize login Manager checking if the session user  exists and is valid.
             * Others calls to others methods of this component before being initialized, should throw
             * exceptions.
             * @return {Promise} Returns a promise that will be fulfilled(initialized loginManager with user logged or not)
             */
            var initialize = function () {
                // check im logged
                var currentAuth = contextHolderManager.get().authentication;
                if (currentAuth.isLogged()) {
                    return _createRegisteredAuthenticationPromise(currentAuth);
                }
                else {
                    if (contextHolderManager._getToken() === undefined) {
                        return _createAnonymousAuthenticationPromise();
                    }
                    else {
                        var authToken = authenticationBuilder.token(contextHolderManager._getToken());
                        return authManager.login(authToken);
                    }
                }
            };
            /**
             * get the current authentication initialized
             * @return {Promise}
             */
            var getAuthentication = function () {
                return initialize();
            };

            /**
             * Check if the user is logged. If not, is redirected to a page where a message that suggests him to sign in is shown
             * TODO: security.securable().logged(function()...).notLogged(function()) si no se pone notLogged entonces ejecuta una function por defecto que es ir a login/needed
             * @param options
             *        if {showError: false} and the user close the 'login view' then the promise is fulfilled with anonymous authentication and don't show the default 'error view'
             *        if send scope, we use to listen the event event:login:no_more_authenticated
             * @return {Promise} Returns a promise that will be fulfilled. by default resolve if the user logged correct and 'stop' the promise if
             * the user close the modal view, then show a message error.
             */
            var securable = function (options) {
                return  initialize()
                    // success
                    .then(function (authentication) {
                        if (authentication.isLogged()) {
                            //logged: ok, fullfill the promise
                            return authentication;
                        } else {
                            if (options && options.showError === false) {
                                // chain with the login promise  (show the modal!)
                                return loginManager.login();
                            } else {
                                // show the modal
                                return loginManager.login()
                                    .then(function (authentication) {
                                        // if not logged: show the error page!
                                        // Don't redirect to the previous page if the user is registering
                                        if (!authentication.isLogged() && $location.path() !== '/register') {
                                            // Get the previous route
                                            var dstLocation = (function (storage) {
                                                var prevRoute = storage.get('prevRoute'),
                                                    dst = (prevRoute || '').split('!/');

                                                return (dst.length > 1) ? dst[1] : undefined;
                                            }(storage));

                                            // Redirect the user to the previous route or the error page in case it does not exist
                                            $location.path(dstLocation || 'login/needed');

                                            return $q.reject();
                                        } else {
                                            //logged: ok, fullfill the promise
                                            return authentication;
                                        }
                                    });
                            }
                        }
                    }, function () {  // unknown error
                        return loginManager.login();
                    })
                    .then(function (authentication) {
                        _configRedirectionIfUserLogoutsAndStaysInSecureZone(authentication, options);
                        return authentication;
                    });
            };

            return{
                initialize : initialize,
                securable : securable,
                getAuthentication : getAuthentication,
                login : authManager.login,
                logout : authManager.logout
            };
        }]);

    upp.service('loginManager', ['$q', '$rootScope', 'contextHolderManager',
        function ($q, $rootScope, contextHolderManager) {
            /**
             * open the login and return promise fullfilled with the authentication.
             * @return {Promise} Returns a promise that will be fulfilled when the user login or the entrypoint/view is
             * closed.
             */
            var login = function () {
                // open the entrypoint.
                show();

                var deferred = $q.defer();
                var promise = deferred.promise;

                var registerClose = $rootScope.$on('event:' + $EVENTS.close, function () {
                    deferred.resolve(contextHolderManager.get().authentication);
                    deregistration();
                });

                var registerSuccess = $rootScope.$on('event:' + $EVENTS.authenticated, function (event, authentication) {
                    deferred.resolve(authentication);
                    deregistration();
                });

                var deregistration = function () {
                    registerClose();
                    registerSuccess();
                };

                return promise;
            };

            /**
             * open login (entrypoint) view
             */
            var show = function () {
                $rootScope.$broadcast('event:' + $EVENTS.open_login);
            };
            /**
             * close login (entrypoint) view
             */
            var close = function () {
                $rootScope.$broadcast('event:' + $EVENTS.close_login);
            };

            return {
                show : show,
                login : login,
                close : close
            };
        }]);

    upp.service('signinManager', ['authManager', 'authenticationBuilder', 'contextHolderManager', 'loginManager',
        function (authManager, AuthenticationBuilder, contextHolderManager, loginManager) {
            /**
             * login with username & password
             * @param username
             * @param password
             * @return promise
             * @protected
             */
            var login = function (username, password) {
                var authentication = AuthenticationBuilder.usernamePassword(username, password);
                return authManager.login(authentication);
            };
            /**
             * logout
             * @return {*}
             * @private
             */
            var logout = function () {
                var currentAuthentication = contextHolderManager.get().authentication;
                return authManager.logout(currentAuthentication);
                /* TODO:
                 if (currentAuthentication !== undefined){
                 return
                 }
                 return */
            };
            /**
             * open the modal
             */
            var open = function () {
                loginManager.show();
            };

            return {
                login : login,
                logout : logout,
                open : open
            };
        }]);

    // Route config
    upp.config(['$routeProvider',
        function ($routeProvider) {
            $routeProvider
                .when('/login/needed', {templateUrl : require('./templates/login-needed.html') });
        }]);

    //Controller for SignIn
    upp.controller('upp.login.SigninCtrl', ['$scope', 'signinManager', 'security', 'contextHolderManager',
        function ($scope, signinManager, security, contextHolderManager) {
            $scope.openLogin = function () {
                signinManager.open();
            };

            $scope.logout = function () {
                signinManager.logout();
            };

            security.initialize()
                .then(function () {
                    // FIXME: si asocio al context directamente la variable authentication, se borra y no se por qué :S
                    $scope.context = contextHolderManager.get();
                });

            /**
             * Is the user logged?
             * @returns {Boolean}
             */
            $scope.isLogged = function () {
                return $scope.context
                    && $scope.context.authentication
                    && $scope.context.authentication.isLogged();
            };
        }]);

    //Directive that shows the login modal dialog if 'event:login:open-login' event received
    upp.directive('modalLoginTpl', ['signinManager', 'utils', '$timeout', 'appi',
        function (signinManager, utils, $timeout, appi) {
            var modal;
            var resetModel = function (scope) {
                scope.loginError = false;
                scope.username = "";
                scope.pass = "";
                scope.remember = false;
            };

            var _checkLogin = function ($scope) {
                $scope.loginError = false;

                $scope.hideError = function () {
                    $scope.loginError = false;
                };

                signinManager.login($scope.username, $scope.pass, $scope.remember)
                    .then(function (authentication) {
                        //OK
                        if (authentication.isLogged()) {
                            modal.modal('toggle');
                            $scope.loginError = false;
                        } else {
                            if (authentication.data != null &&
                                authentication.data.data != null &&
                                // TODO move to constant
                                authentication.data.data.errorMessageCode === 'user.status.waiting') {
                                // USER need to be activated
                                modal.modal('toggle');
                                appi.location.path("/activate/" + $scope.username);
                            } else {
                                //FAIL
                                $scope.loginError = true;
                            }
                        }
                    });
            };

            return {
                restrict : 'E',
                replace : true,
                templateUrl : require('./templates/login.html'),
                controller : ['$scope', 'location',
                    function ($scope, location) {
                        $scope.checkLogin = function () {
                            _checkLogin($scope);
                        };

                        $scope.openRestoreModal = function () {
                            // We have to wait until the login modal closes so the close modal animation
                            // and the open modal animation of the restore popup don't overlap
                            $timeout(function () {
                                $scope.$broadcast('emailRestore:open');
                            }, 600);
                        };

                        $scope.redirectToRegister = function () {
                            location.path('register');
                        };
                    }],
                link : function (scope, element) {
                    // open the modal
                    scope.$on('event:' + $EVENTS.open_login, function () {
                        modal = modal || element;

                        resetModel(scope);
                        modal.modal('show');
                        modal.one('shown', function () {
                            $('#username, #pass').unbind('mouseup mousedown');
                        });

                        // send event
                        modal.one('hidden', function () {
                            // FIXME: workaround para que le de tiempo a terminar la transición :S
                            $timeout(function () {
                                utils.broadcast($EVENTS.close);
                            }, 500);

                        });

                        // submit with ENTER key
                        modal.unbind('keypress').bind('keypress', function (event) {
                            if (event.which == 13) {  //Enter
                                event.preventDefault();
                                _checkLogin(scope);
                            }
                        });

                        // close the modal
                        scope.$on('event:' + $EVENTS.close_login, function () {
                            modal.modal('hide');
                        });
                    });
                }
            }
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/plugins/login/security.js